var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import CloseIcon from '../../assets/icons/Close';
import { useTheme } from '../../themes';
import AccessoryWrapper from '../AccessoryWrapper';
import { Typography } from '../Typography';
import { customTagProps } from './modifiers';
import * as S from './styles';
export var Tag = forwardRef(function (props, ref) {
    var label = props.label, labelColor = props.labelColor, iconLeft = props.iconLeft, hasIconLeft = props.hasIconLeft, iconRight = props.iconRight, hasIconRight = props.hasIconRight, onClose = props.onClose, rest = __rest(props, ["label", "labelColor", "iconLeft", "hasIconLeft", "iconRight", "hasIconRight", "onClose"]);
    var theme = useTheme();
    var tagStyleProps = customTagProps(__assign(__assign({}, props), { theme: theme }));
    var iconSpacing = theme.spacing.xxxs;
    var labelPadding = function () { return ({
        marginLeft: iconLeft || hasIconLeft ? 0 : iconSpacing,
        marginRight: iconRight || hasIconRight ? 0 : iconSpacing,
    }); };
    return (
    // @ts-ignore
    _jsxs(S.Container, __assign({ ref: ref }, tagStyleProps, { "data-testid": "tag" }, rest, { children: [(iconLeft || hasIconLeft) && (_jsx(AccessoryWrapper, __assign({ "data-testid": "iconLeft", mLeft: "nano", mRight: "quark", onClick: onClose, color: labelColor || tagStyleProps.labelColor, opacity: 0.5 }, { children: iconLeft || (_jsx(CloseIcon, { fill: labelColor || tagStyleProps.labelColor })) }))), _jsx("div", __assign({ style: __assign({}, labelPadding()) }, { children: _jsx(Typography, __assign({}, tagStyleProps.labelTypographyProps, { textAlign: "center", color: tagStyleProps.labelColor }, { children: label })) })), (iconRight || hasIconRight) && (_jsx(AccessoryWrapper, __assign({ "data-testid": "iconRight", mLeft: "quark", mRight: "nano", onClick: onClose, color: labelColor || tagStyleProps.labelColor, opacity: 0.5 }, { children: iconRight || (_jsx(CloseIcon, { fill: labelColor || tagStyleProps.labelColor })) })))] })));
});
